import { Box } from "@mui/material";
import DocContent from "./DocContent";
import DocInput from "./DocInput";

function DocComponent({
  quadrantId,
  mandatory,
  value,
  onChange,
  isEditing = false,
  quadrantData = {},
  ...rest
}) {
  const { confidential } = quadrantData;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
      }}
      disableGutters
    >
      {isEditing && <DocInput initialValue={value} onChange={onChange} />}
      <DocContent
        isConfidential={confidential === "S"}
        value={value}
        contentId={quadrantData.chapterContentId}
        mandatory={mandatory}
        {...rest}
      />
    </Box>
  );
}
export default DocComponent;
